import Vue from 'vue'
import Vuex from 'vuex'
let markdown = require( "markdown" ).markdown;

var Airtable = require('airtable')

const base = new Airtable({apiKey: process.env.VUE_APP_AIRTABLE}).base('appCCtBAz9A9OJMUe')
// const baseMenu = new Airtable({apiKey: process.env.VUE_APP_AIRTABLE}).base('appWSdc7xb1IwfLRH')

Vue.use(Vuex)

function splitPrice (text) {
  if (text.indexOf('|') > -1) {
    let split = text.split('|')
    return [
      'div',
      [
        'div',
        { 'class': 'flex flex-justify-between'},
        [
          'div',
          { 'class': 'menu-item-title flex-auto' },
          split[0].trim()
        ],
        [
          'div',
          { 'class': 'menu-item-price right-align' },
          split[1].trim()
        ]
      ]
    ]
  } else {
    return text
  }
}

function processMenu (content) {

  let tree = markdown.toHTMLTree(content)

  for (var i = 1; i < tree.length; i++) {
    let item = tree[i]

    if (item[0] !== 'ul') {
      item[1] = splitPrice(item[1])
    } else if (item[0] === 'ul') {
      for (var j = 1; j < item.length; j++) {
        item[j][1] = splitPrice(item[j][1])
      }
    }
  }

  return markdown.renderJsonML(tree)

    // return processed
  }

export default new Vuex.Store({
  state: {
    booking: null,
    menu: null,
    programItems: null,
    hoursText: null
  },
  mutations: {
    UPDATE_BOOKING (state, payload) {
      state.booking = payload
    },
    UPDATE_MENU (state, payload) {
      state.menu = payload
    },
    UPDATE_PROGRAM_ITEMS (state, payload) {
      console.log(payload)
      state.programItems = payload
    },
    UPDATE_HOURS (state, payload) {
      state.hoursText = payload
    }
  },
  actions: {
    loadMenuItems: function (context) {
      base('Menu').find('recjEDeN8MHYTX1CJ', function(err, record) {
        if (err) {
          context.commit('UPDATE_MENU', false)
          return
        }
        context.commit('UPDATE_MENU', processMenu(record.fields.Content))
      })
    },
    loadBooking: function (context) {
      base('Menu').find('rec5fxz3hRSGVJKzr', function(err, record) {
        if (err) {
          context.commit('UPDATE_BOOKING', false)
          return
        }
        context.commit('UPDATE_BOOKING', record.fields)
      })
    },
    loadHours: function (context) {
      base('Menu').find('recdj9liT2oguppXa', function(err, record) {
        if (err) {
          context.commit('UPDATE_HOURS', false)
          return
        }
        context.commit('UPDATE_HOURS', record.fields.Content)
      })
    },
    loadProgramItems: function (context) {
      let programItems = []

      base('Program').select({
        maxRecords: 100,
        view: 'List'
      }).eachPage((records, fetchNextPage) => {
        records.forEach(function (record) {
          programItems.push(record.fields)
        })
        fetchNextPage()
      }, function done (err) {
        if (err) { context.commit('UPDATE_PROGRAM_ITEMS', false) } else {
           context.commit('UPDATE_PROGRAM_ITEMS', programItems)
        }
      })
    }
  }
})
